var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isCCNSW)?_c('forgot-password-page-ccnsw'):(_vm.isStatewide)?_c('forgot-password-page-stw'):_c('forgot-password-page-default')
}
var staticRenderFns = []

export { render, staticRenderFns }